import React from 'react';
import "./Page3.css";
import sag_pic from "../images/mypic.jpg";

export default function Page3() {



    return (
        <div className="page3" >
            <div className='container'>
                <div className="content3">
                    <img src={sag_pic} className="pic2" alt="mypic.jpg" />
                    <div className="titles">
                        <span style={{ fontSize: "1.7rem", fontWeight: "bold", color: "rgb(201, 0, 67)" }}>About me<br /><hr /></span>
                        <br />

                        <p className="allInform">
                            Hi from <i>Sagar</i><br/> <br/>I am a full time Java Developer  with experience of 2.5+ years in MNC (Accenture).
                            I have worked in microservice based project which uses technology like React, Springboot, REST. 
                            I have also experience in Devops. 
                            I love to code and hence I am a proud {'Developer</>'}
                        </p>
                        <br />
                    </div>
                </div>
            </div>

        </div>

    )
}
